import { TranslateService } from '@ngx-translate/core';

import {
    ColumnConfigItem,
    Icon,
} from '../../../coaching-insight/oa/models/coaching.global.model';
import { SortDirection } from '../../../coaching-insight/oa/models/sorting.model';
import { TranslationKeyMap } from '../main-fl.i18n';
const textAlign = 'text-align';
const headersContent = 'headers-content';
export function getFrontlineColumnConfigItemsConfig(
    tls: TranslateService,
): ColumnConfigItem[] {
    return [
        new ColumnConfigItem({
            header: tls.instant(TranslationKeyMap._7443_TEAM___),
            colstyle: {
                width: '20rem',
                'max-width': '20rem',
                'min-width': '12rem',
            },
            active: true,
            styles: {},
            class: [],
            headerContentClass: 'header-content-oa',
            cellstyles: {
                [textAlign]: 'left',
            },
        }),
        new ColumnConfigItem({
            header: tls.instant(TranslationKeyMap._11064_FRONTLINE_MI2___),
            active: true,
            colstyle: { width: '10%' },
            styles: {
                width: '10%',
                'min-width': '6.5rem',
                'max-width': '6.5rem',
            },
            icon: [
                new Icon({
                    class: [
                        'chevron-up',
                        'chevron-down',
                        'unfold-more-horizontal',
                    ],
                    counter: SortDirection.DESC,
                    defaultState: SortDirection.DESC,
                    state: true,
                    action: 'sortTeamByScore',
                    prop: 'oaSort',
                    actionParams: {},
                }),
            ],
            class: [],
            headerContentClass: headersContent,
            cellstyles: {
                [textAlign]: 'center',
            },
        }),
        new ColumnConfigItem({
            header: tls.instant(
                TranslationKeyMap._11152_TOTAL_DIRECT_REPORTS___,
            ),
            active: true,
            colstyle: { width: '12%' },
            styles: {
                width: '12%',
                'min-width': '7.5rem',
                'max-width': '7.5rem',
            },
            icon: [
                new Icon({
                    class: [
                        'chevron-up',
                        'chevron-down',
                        'unfold-more-horizontal',
                    ],
                    counter: SortDirection.DEFAULT,
                    state: true,
                    action: 'sortTeamByExpected',
                    prop: 'expectedSort',
                    actionParams: {},
                }),
            ],
            class: [],
            headerContentClass: headersContent,
            cellstyles: {
                [textAlign]: 'center',
            },
        }),
        new ColumnConfigItem({
            header: tls.instant(TranslationKeyMap._11153_MI2_DATA___),
            active: true,
            colstyle: {
                width: '23%',
            },
            colclass: 'last-col',
            styles: {
                width: '23%',
                'max-width': '94rem',
            },
            class: ['funded-coaching-bar-container'],
            headerContentClass: 'headers-content',
            cellstyles: {
                [textAlign]: 'center',
            },
            left: {
                class: 'mi2-grid-legend-box',
                content: `
                    <div class='mi2-grid-legend-box-coached'>
                        <span>${
                            tls.instant(
                                TranslationKeyMap._11154_IMPROVING___,
                            ) as string
                        }</span>
                    </div>
                    <div class='mi2-grid-legend-box-uncoached'>
                        <span>${
                            tls.instant(
                                TranslationKeyMap._11155_DECLINING___,
                            ) as string
                        }</span>
                    </div>
                `,
            },
            right: {
                class: 'funded-coaching-legend',
                content: `
                    <div class="no-score-label">
                    ${
                        tls.instant(
                            TranslationKeyMap._9879_NO_SCORE___,
                        ) as string
                    }</div>
                `,
            },
        }),
    ];
}
